export const STATES = [
    {
        "text": "Select State",
        "key": ""
    },
    {
        "text": "Alabama",
        "key": "AL"
    },
    {
        "text": "Alaska",
        "key": "AK"
    },
    {
        "text": "Arizona",
        "key": "AZ"
    },
    {
        "text": "Arkansas",
        "key": "AR"
    },
    {
        "text": "California",
        "key": "CA"
    },
    {
        "text": "Colorado",
        "key": "CO"
    },
    {
        "text": "Connecticut",
        "key": "CT"
    },
    {
        "text": "Delaware",
        "key": "DE"
    },
    {
        "text": "District Of Columbia",
        "key": "DC"
    },
    {
        "text": "Florida",
        "key": "FL"
    },
    {
        "text": "Georgia",
        "key": "GA"
    },
    {
        "text": "Hawaii",
        "key": "HI"
    },
    {
        "text": "Idaho",
        "key": "ID"
    },
    {
        "text": "Illinois",
        "key": "IL"
    },
    {
        "text": "Indiana",
        "key": "IN"
    },
    {
        "text": "Iowa",
        "key": "IA"
    },
    {
        "text": "Kansas",
        "key": "KS"
    },
    {
        "text": "Kentucky",
        "key": "KY"
    },
    {
        "text": "Louisiana",
        "key": "LA"
    },
    {
        "text": "Maine",
        "key": "ME"
    },
    {
        "text": "Maryland",
        "key": "MD"
    },
    {
        "text": "Massachusetts",
        "key": "MA"
    },
    {
        "text": "Michigan",
        "key": "MI"
    },
    {
        "text": "Minnesota",
        "key": "MN"
    },
    {
        "text": "Mississippi",
        "key": "MS"
    },
    {
        "text": "Missouri",
        "key": "MO"
    },
    {
        "text": "Montana",
        "key": "MT"
    },
    {
        "text": "Nebraska",
        "key": "NE"
    },
    {
        "text": "Nevada",
        "key": "NV"
    },
    {
        "text": "New Hampshire",
        "key": "NH"
    },
    {
        "text": "New Jersey",
        "key": "NJ"
    },
    {
        "text": "New Mexico",
        "key": "NM"
    },
    {
        "text": "New York",
        "key": "NY"
    },
    {
        "text": "North Carolina",
        "key": "NC"
    },
    {
        "text": "North Dakota",
        "key": "ND"
    },
    {
        "text": "Ohio",
        "key": "OH"
    },
    {
        "text": "Oklahoma",
        "key": "OK"
    },
    {
        "text": "Oregon",
        "key": "OR"
    },
    {
        "text": "Pennsylvania",
        "key": "PA"
    },
    {
        "text": "Rhode Island",
        "key": "RI"
    },
    {
        "text": "South Carolina",
        "key": "SC"
    },
    {
        "text": "South Dakota",
        "key": "SD"
    },
    {
        "text": "Tennessee",
        "key": "TN"
    },
    {
        "text": "Texas",
        "key": "TX"
    },
    {
        "text": "Utah",
        "key": "UT"
    },
    {
        "text": "Vermont",
        "key": "VT"
    },
    {
        "text": "Virginia",
        "key": "VA"
    },
    {
        "text": "Washington",
        "key": "WA"
    },
    {
        "text": "West Virginia",
        "key": "WV"
    },
    {
        "text": "Wisconsin",
        "key": "WI"
    },
    {
        "text": "Wyoming",
        "key": "WY"
    }
];